import { Box, Grid, Paper } from "@mui/material";
import React from "react";

interface TwoPanelLayoutProps {
  leftPanel: React.ReactNode;
  rightPanel: React.ReactNode;
  leftPanelWidth?: number; // Grid columns (out of 12)
  spacing?: number;
  leftPanelProps?: object;
  rightPanelProps?: object;
}

const TwoPanelLayout: React.FC<TwoPanelLayoutProps> = ({
  leftPanel,
  rightPanel,
  leftPanelWidth = 4,
  spacing = 3,
  leftPanelProps = {},
  rightPanelProps = {},
}) => {
  const rightPanelWidth = 12 - leftPanelWidth;

  return (
    <Box sx={{ flexGrow: 1, p: { xs: 2, sm: 3, md: 4 } }}>
      <Grid container spacing={spacing}>
        {/* Left Panel */}
        <Grid size={{ xs: 12, md: leftPanelWidth }}>
          <Paper
            elevation={1}
            sx={{
              height: "fit-content",
              minHeight: "400px",
              ...leftPanelProps,
            }}
          >
            {leftPanel}
          </Paper>
        </Grid>

        {/* Right Panel */}
        <Grid size={{ xs: 12, md: rightPanelWidth }}>
          <Paper
            elevation={1}
            sx={{
              height: "fit-content",
              minHeight: "400px",
              ...rightPanelProps,
            }}
          >
            {rightPanel}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TwoPanelLayout;
